// extracted by mini-css-extract-plugin
export default {"extension":"app-people-PersonEditForm-PersonEditForm-module__xPjFe4CEybVZxh2xOOSA"};